import React from 'react'
import Header from '../../Layouts/Header'
import Topbar from '../../Layouts/Topbar'
import Homebanner from './Homebanner'
import Toprestaurants from './Toprestaurants'
import Featuredrestaurants from './Featuredrestaurants'
import Homeblogs from './Homeblogs'
import Footer from '../../Layouts/Footer'
import MovieScreens from './MovieScreens'
import MovieList from './MovieList'
import MovieFoodSection from './MovieFoodSection'
const Home = () => {
  return (
    <>
    <Topbar/>
    <Header/>
    <Homebanner/>
    <MovieScreens/>
    <MovieList/>
    <MovieFoodSection/>
    <Footer/>
    </>
  )
}

export default Home
